// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"CustomerTasks_scrollbar__RYZ35"};